<template>
  <el-sub-menu
    v-if="menu?.isFolder"
    :index="menu?.id"
    :class="`menu-folder ${!isChildren ? 'no-children' : ''}`"
    @click="handleClick"
  >
    <template #title>
      <menu-icon class="q-pr-sm" :menu="menu" />
      <span>{{ menu.folderName || menu.itemName }}</span>
    </template>

    <template v-for="it in menu.children || []" :key="`mf_${it.id}`">
      <menu-folder-collapse-sub
        v-if="it?.children?.length > 0"
        :menu="it"
        :collapse="collapse"
      ></menu-folder-collapse-sub>
      <menu-item v-else :menu="it" :collapse="true">{{ it.folderName }}</menu-item>
    </template>
  </el-sub-menu>
</template>

<script setup lang="ts">
import { computed, ref, useHostAppInstance } from '@zto/zpage'
import { ElementPlusIcons } from '@zto/zpage-ui-element'

import { fetchFavItems } from '../../../../utils/fav'

import MenuFolderCollapseSub from './menu-folder-collapse-sub.vue'
import MenuItem from './menu-item.vue'

import MenuIcon from './menu-icon.vue'
import MenuTitle from './menu-title.vue'

const props = withDefaults(
  defineProps<{
    menu?: any
    collapse?: boolean
  }>(),
  {
    collapse: false
  }
)

const emit = defineEmits(['remove', 'click'])

const app = useHostAppInstance()

const dropdownRef = ref<any>()

const currentMenu = computed(() => {
  return props.menu || []
})

const isFolder = computed(() => {
  return currentMenu.value.isFolder === true
})

const isChildren = computed(() => {
  return !!props.menu.children?.length
})

async function handleClick() {
  const menu = props.menu

  if (!menu) return
  if (menu.children?.length) return

  menu.children = await fetchFavItems(app, menu.id)
}
</script>

<style lang="scss" scoped>
.menu-folder {
  :deep(.el-sub-menu__title) {
    padding-right: 40px;
  }

  &.no-children {
    :deep(.el-sub-menu__icon-arrow) {
      display: none;
    }

    :deep(.el-sub-menu__title) {
      padding-right: 20px;
    }
  }
}
</style>
